import React from "react";

const Tabs = ({
  tabs,
  selectedTab,
  onTabChange,
  className,
  buttonCommonClassName,
}) => {
  const buttonSelectedStyle = `tw-bg-purple-700 tw-text-white`;
  const buttonCommonStyle = `tw-p-2 tw-px-2.5 tw-rounded-full tw-cursor-pointer tw-text-gray-500 tw-font-black tw-transition-all ${buttonCommonClassName}`;

  return (
    <div
      className={`tw-flex tw-w-max tw-bg-gray-100 tw-p-1 tw-rounded-full tw-font-bold tw-gap-1 tw-items-center ${className}`}
    >
      {tabs.map((tab) => (
        <div
          key={tab.id}
          onClick={() => onTabChange(tab.id)}
          className={`${selectedTab === tab.id ? buttonSelectedStyle : ""} ${buttonCommonStyle} tw-flex tw-gap-1`}
        >
          {tab.label}
        </div>
      ))}
    </div>
  );
};

export default Tabs;
